import { ProgressActivity } from '../asset';
import { joinCn } from '../util';

type VLoadingSpinnerProps = {
  className?: string;
};

const VLoadingSpinner = ({ className }: VLoadingSpinnerProps) => {
  return (
    <ProgressActivity
      className={joinCn('h-8 w-8 animate-spin text-secondary-300', className)}
    />
  );
};

export default VLoadingSpinner;
